import * as z from 'zod';

export const editUserAdminFormSchema = z.object({
  role: z.array(z.enum(['admin', 'executive-admin', 'approver'])),
  deactivated: z.boolean().default(false),
  approverPermissions: z
    .record(
      z.string(), // school category ID
      z.object({
        label: z.string(), // category name
        value: z.boolean(), // whether permission is granted
      }),
    )
    .optional(),
});

export type EditUserAdminForm = z.TypeOf<typeof editUserAdminFormSchema>;
